import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M21.75 19.503H16.5v-1.61a2.25 2.25 0 0 1 1.244-2.012l2.89-1.445c.65-.326 1.116-.955 1.116-1.683q0-.749-.118-1.463c-.135-.825-.835-1.422-1.668-1.489a15.2 15.2 0 0 0-3.464.12M2.243 4.494v7.5m0 0v7.502m0-7.501h10.5m0-7.5v7.5m0 0v7.501"
    }, null, -1)
  ])))
}
export default { render: render }